export const nameRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		rule: 'minLength',
		value: 1,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'customRegexp',
		value: /^[A-Za-zА-ЯЁа-яё’-]+$/,
		errorMessage: 'Неверный формат',
	},
];
export const emailRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		rule: 'email',
		errorMessage: 'Неверный формат',
	},
];
export const birthdateRules = [
	{
		rule: 'required',
		errorMessage: 'Обязательное поле',
	},
	{
		validator: (value) => {
			return value.length > 9;
		},
		errorMessage: 'Неверный формат',
	},
];
export const addressRules = [
	{
		rule: 'customRegexp',
		value: /^(?![.,\-"'()/&]+$)[А-ЯЁа-яёA-Za-z0-9 .,\-"'()/&]+$/,
		errorMessage: 'Неверный формат',
	},
	{
		rule: 'minLength',
		value: 1,
		errorMessage: 'Неверный формат',
	},
];

export const getErrorContainer = (input) =>
	input?.closest('[data-input]')?.querySelector('.input__error-text');
